/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
   LOAD_RECORDS_VALID_CACHE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_DROPDOWN_SUCCESS,
  LOAD_DROPDOWN_ERROR
} from "./constants";

const initialState = {
  employee_list: [],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
  dropDownList:{}
};

const Reducer = (
  state = initialState,
  {
    type,
    employee_list,
    dropDownList,
    error,
  }
) => {
  return produce(state, (draft) => {
    switch (type) {
      case LOAD_RECORDS_VALID_CACHE:
        draft.loading = false;
        draft.error = false;
        draft.success = false;
        break;
     
      case LOAD_EMPLOYEE_SUCCESS:
        draft.employee_list = employee_list;
        draft.error = false;
        draft.success = false;
        break;
        case LOAD_DROPDOWN_SUCCESS:
          draft.dropDownList = dropDownList;
          draft.error = false;
          draft.success = false;
          break;
      case LOAD_DROPDOWN_ERROR:
      case LOAD_EMPLOYEE_ERROR:
        draft.error = error;
        draft.success = false;
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
